import { BULK_APPROVE_TASK, EMP_LIST, EMP_LIST_BYPROJECTID, SUP_LIST } from "./ActionType";
import { BASE_API_URL } from "../../config/Api";

export const empList = (token,role) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/empList?role=${role}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: role === "SUP" ? SUP_LIST:EMP_LIST, payload: resData });
  } catch (error) {}
};

export const bulkApproveDailyUpdate = (fromDate, toDate, token) => async (dispatch) => {
    try {
        const res = await fetch(`${BASE_API_URL}/bulk-approve-daily-update?fromDate=${fromDate}&toDate=${toDate}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData = await res.json();
        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: BULK_APPROVE_TASK, payload: resData });
            return { success: true };
        } else {
            return { success: false, error: resData.message || 'An unknown error occurred' };
        }
    } catch (error) {

    }
}

export const getEmpListByProjectId = (projectMasterId,projectCode,token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/empListByProjectId?projectMasterId=${projectMasterId}&projectCode=${projectCode}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: EMP_LIST_BYPROJECTID, payload: resData });
  } catch (error) {}
};
